export default __webpack_public_path__ + "static/media/top-img.4575dd51.jpg";